/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  TelegramLinkResponse,
  TelegramVerificationResponse,
  VerifyTelegramLinkRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TelegramLinkResponseFromJSON,
    TelegramLinkResponseToJSON,
    TelegramVerificationResponseFromJSON,
    TelegramVerificationResponseToJSON,
    VerifyTelegramLinkRequestFromJSON,
    VerifyTelegramLinkRequestToJSON,
} from '../models/index';

export interface VerifyTelegramLinkOperationRequest {
    verifyTelegramLinkRequest: VerifyTelegramLinkRequest;
}

/**
 * 
 */
export class IntegrationsApi extends runtime.BaseAPI {

    /**
     * Generates a unique, short-lived Telegram deep link for the authenticated user to initiate account linking from the web application.
     * Generate Telegram Deep Link
     */
    async generateTelegramLinkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TelegramLinkResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/integrations/telegram/generate-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TelegramLinkResponseFromJSON(jsonValue));
    }

    /**
     * Generates a unique, short-lived Telegram deep link for the authenticated user to initiate account linking from the web application.
     * Generate Telegram Deep Link
     */
    async generateTelegramLink(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TelegramLinkResponse> {
        const response = await this.generateTelegramLinkRaw(initOverrides);
        return await response.value();
    }

    /**
     * Verifies the token received via the Telegram deep link (/start command payload). Called by the Telegram bot to associate a Telegram User ID with a SaaS user account. This endpoint should NOT require standard user authentication (bearerAuth) as it\'s called by the bot.
     * Verify Telegram Link Token
     */
    async verifyTelegramLinkRaw(requestParameters: VerifyTelegramLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TelegramVerificationResponse>> {
        if (requestParameters['verifyTelegramLinkRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyTelegramLinkRequest',
                'Required parameter "verifyTelegramLinkRequest" was null or undefined when calling verifyTelegramLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/integrations/telegram/verify-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyTelegramLinkRequestToJSON(requestParameters['verifyTelegramLinkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TelegramVerificationResponseFromJSON(jsonValue));
    }

    /**
     * Verifies the token received via the Telegram deep link (/start command payload). Called by the Telegram bot to associate a Telegram User ID with a SaaS user account. This endpoint should NOT require standard user authentication (bearerAuth) as it\'s called by the bot.
     * Verify Telegram Link Token
     */
    async verifyTelegramLink(requestParameters: VerifyTelegramLinkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TelegramVerificationResponse> {
        const response = await this.verifyTelegramLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
